export default {
  USER_HASH: 'samuid',
  DEVICE_UID: 'uid',
  PROFILE_UID: 'profile_uid',
  SUBSCRIBER_PUB: 'subscriber_pub',
  SUBSCRIBER_HASH: 'subscriber_hash',
  WATCHED_HASH: 'cache_bookmark_watched',
  FAVOURITE_HASH: 'cache_bookmark_favourite',
  RATING_HASH: 'cache_bookmark_rating',
};
